if (!customElements.get('kh-faq-tabs')) {
  customElements.define('kh-faq-tabs', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.tabs = [...this.querySelectorAll('[data-kh-ft-tab]')];
      this.panels = [...this.querySelectorAll('[data-kh-ft-group]')];

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-kh-ft-tab]');
        if (tab) this.selectTab(tab);
      }, options);

      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-kh-ft-tab]');
        if (!tab) return;
        const index = this.tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.selectTab(this.tabs[next]);
        this.tabs[next].focus();
      }, options);

      this.addEventListener('shopify:block:select', (event) => {
        const block = [...this.querySelectorAll('[data-block-id]')]
          .find((item) => item.dataset.blockId === event.detail.blockId);
        if (!block) return;
        if (block.matches('[data-kh-ft-tab]')) {
          this.selectTab(block);
        } else {
          const panel = block.closest('[data-kh-ft-group]');
          this.selectTab(this.tabs.find((tab) => tab.getAttribute('aria-controls') === panel.id));
          block.open = true;
        }
      }, options);
    }

    selectTab(selected) {
      if (!selected) return;
      this.tabs.forEach((tab) => {
        const active = tab === selected;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        const active = panel.id === selected.getAttribute('aria-controls');
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    disconnectedCallback() {
      this.events.abort();
    }
  });
}
